
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import store from '../../vuex/store'
import { go } from '../../libs/router'
export default {
components: {
XInput,
XButton,
Group,
Cell
},
data () {
return {
invoiceCode: '0500035100',
invoiceNum: '31020060',
date: '2017-3-20',
price: '120'
}
},
mounted () {
store.commit( 'UPDATE_TITLE', '发票详情' )
},
created () {
store.commit( 'UPDATE_SHOW_FOOTER', false )
},
methods: {
onClick ( link ) {
go( link, this.$router )
}
}
}



// WEBPACK FOOTER //
// ./src/components/fpj/scdzfp.vue